/**
 * @see https://umijs.org/zh-CN/plugins/plugin-access
 * */
export default function access(initialState: { currentUser?: API.CurrentUser; isOrganizationInfo?: any } | undefined) {
  const { currentUser, isOrganizationInfo } = initialState ?? {};
  console.log('initialState', initialState);
  return {
    isRoleIntaller: APP_ROLE === 'installer', // 安装商端的安装商角色
    isRoleManager: APP_ROLE === 'manager', // 安装商端的CED/Saled角色
    isOrganizationInfo: isOrganizationInfo, // OrganizationInfo是否有值,
    isSettingshow: APP_ROLE === 'manager' || (APP_ROLE === 'installer' && isOrganizationInfo), // 看到Setting
  };
}
